import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";

/** Read-only comment list for admin blog preview */
const CommentSection = ({ blogId, slug }) => {
    const resolvedBlogId = blogId ?? slug;
    const [comments, setComments] = useState([]);
    const [visibleCount, setVisibleCount] = useState(2);
    const navigate = useNavigate();
    const url = API_BASE_URL;

    useEffect(() => {
        if (!resolvedBlogId) return;
        fetch(`${url}/blog-comment/${resolvedBlogId}`)
            .then((res) => res.json())
            .then((data) => setComments(Array.isArray(data.data) ? data.data : []))
            .catch((err) => console.error("Error fetching comments:", err));
    }, [resolvedBlogId, url]);

    return (
        <div className="bg-white border border-gray-200 rounded-lg p-4 my-3">
            <h3 className="flex items-center gap-2 text-lg font-semibold text-black mb-3">
                <MessageCircle className="text-[#4e59c2]" size={18} />
                Comments ({comments.length})
            </h3>

            <ul className="space-y-3">
                {comments.slice(0, visibleCount).map((comment) => (
                    <li
                        key={comment.id}
                        className="p-3 bg-gray-50 border border-gray-200 rounded-md"
                    >
                        <div className="flex justify-between items-center mb-1">
                            <strong className="text-black text-sm">
                                {comment.author || "Anonymous"}
                            </strong>
                            <span className="text-xs text-gray-500">
                                {new Date(comment.createdAt).toLocaleString()}
                            </span>
                        </div>
                        <p className="text-gray-800 text-sm">{comment.message}</p>
                    </li>
                ))}
            </ul>

            {comments.length > visibleCount && (
                <div className="mt-3 text-center">
                    <button
                        type="button"
                        onClick={() => setVisibleCount(comments.length)}
                        className="text-[#4e59c2] hover:text-[#3e4096] text-sm font-medium"
                    >
                        Show more
                    </button>
                </div>
            )}

            <div className="mt-3 text-center">
                <button
                    type="button"
                    onClick={() => navigate("/comment")}
                    className="text-[#4e59c2] hover:text-[#3e4096] text-sm font-medium"
                >
                    Open comment moderation
                </button>
            </div>
        </div>
    );
};

export default CommentSection;
